import { FC } from 'react';

import { CenterModal, ModalFooter } from 'shared/components';
import { Button, Text, openNotification } from 'shared/components/ui';
import { useUnshareProjectMutation } from 'services';

import styles from './index.module.scss';

interface Props {
	onClose: () => void;
	projectId: number;
	user_email: string;
}

export const UnshareProjectModal: FC<Props> = ({ onClose, projectId, user_email }: Props) => {
	const [unshareProject] = useUnshareProjectMutation();

	const handleDeleteUser = (email: string) => async () => {
		try {
			await unshareProject({ projectId, email }).unwrap();
			openNotification({ text: 'Access removed!' });
		} catch (error) {
			console.error('Unshare project error:', error);
		}
		onClose();
	};

	return (
		<CenterModal onClose={onClose} icon="trash" iconColor="red">
			<div className={styles.body}>
				<Text variant="inter/20/medium" color="dark_blue">
					Remove from project?
				</Text>
				<Text variant="inter/14/regular" color="grey">
					This person will no longer have access to your project. You can re-invite them at any time.
				</Text>
				<Text variant="inter/16/regular">{user_email}</Text>
			</div>
			<ModalFooter>
				<Button type="ghost" onClick={onClose}>
					Cancel
				</Button>
				<Button className={styles.button} type="danger" block onClick={handleDeleteUser(user_email)}>
					Delete
				</Button>
			</ModalFooter>
		</CenterModal>
	);
};
